import {
  AccountCircleOutlined,
  ArrowRightAlt,
  BarChart,
  Delete,
  DeleteOutline,
  DeleteTwoTone,
  Edit,
  EditOutlined,
  FolderOutlined,
  FolderSpecial,
  FolderSpecialOutlined,
  FolderSpecialTwoTone,
  GraphicEqOutlined,
  MoreHoriz,
  MoreVert,
  PlayArrow,
} from "@mui/icons-material";
import {
  alpha,
  Avatar,
  Box,
  Breadcrumbs,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Popover,
  Typography,
  useTheme,
} from "@mui/material";
import { font } from "../../styles/font";
import { blue, brown, green, grey, red } from "@mui/material/colors";
import { useState } from "react";
import { LightTooltip } from "../styled/CustomComponent";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import ShortcutText from "../common/ShortcutText";
import { KeyboardKeys } from "../../constant/KeyboardKeys";
import {
  ProjectCustomIcon,
  TestCaseCustomIcon,
  UseCaseCustomIcon,
  UserStoryCustomIcon,
} from "../styled/CustomIcons";
import CreatedByAvatar from "../common/CreatedByAvatar";
import { CARD_COLOR } from "../../constant/ApplicationJson";
import { Entity, ModulePath } from "../../constant/ApplicationVariables";
// import { Key } from 'ts-key-enum'

const ITEM_HEIGHT = 48;

function ProjectCard({
  item,
  handleClick,
  handleEditClick,
  handleClickDelete,
}) {
  const theme = useTheme();
  const { t } = useTranslation("translation", { keyPrefix: "project" });

  let cardColor = CARD_COLOR[Entity.project] || grey[50];

  const options = [
    {
      label: "Edit Story",
      icon: <Edit sx={{ color: theme.palette.secondary.main }} />,
      onClick: () => console.log("Edit Story"),
    },
    {
      label: "Delete Story",
      icon: <Delete color="error" />,
      onClick: () => console.log("Delete Story"),
    },
  ];

  const [moreAnchorEl, setMoreAchorEl] = useState(null);

  const handleEdit = (e) => {
    e && e.stopPropagation();
    handleEditClick();
  };

  const handleDelete = (e) => {
    e && e.stopPropagation();
    handleClickDelete();
  };

  const handleOpenMore = (event) => {
    setMoreAchorEl(event.currentTarget);
  };
  const handleCloseMore = () => {
    setMoreAchorEl(null);
  };

  return (
    <Box
      onClick={() => handleClick(item, ModulePath.requirements)}
      title={`${item?.name}\n${item?.description}`}
      className="
    relative overflow-hidden
    rounded-[10px]
    flex flex-col justify-between
    w-full h-full gap-4 px-4 py-4
    
    transition-all duration-300
    bg-card text-card-foreground
   
    
    before:content-['']
    before:absolute
    before:inset-0
    before:rounded-[10px]
    before:pointer-events-none
    before:border
    before:border-[hsl(var(--cyan)/0.7)] 
    
  "
    >
      {/* TOP */}
      <span
        className="
    absolute top-0 left-2 right-2 h-[1px]
    bg-[linear-gradient(to_right,transparent,hsl(var(--cyan)/0.6),transparent)]
  "
      />

      {/* RIGHT */}
      <span
        className="
    absolute top-0 right-0 w-[1px] h-full
    bg-[linear-gradient(hsl(var(--cyan)/0.6),transparent)]
    dark:bg-[linear-gradient(hsl(var(--cyan)/0.85)]
  "
      />

      {/* BOTTOM */}
      <span
        className="
    absolute bottom-0 left-0 w-full h-[1px]
    bg-[linear-gradient(hsl(var(--cyan)/0.6),transparent)]
    dark:bg-[linear-gradient(hsl(var(--cyan)/0.85)]
  "
      />

      {/* LEFT */}
      <span
        className="
    absolute top-2 bottom-2 left-0 w-[1px]
    bg-[linear-gradient(to_bottom,transparent,hsl(var(--cyan)/0.6),transparent)]
  "
      />

      {/* upper container */}
      <Box className="flex items-center gap-2 px-0    ">
        <Avatar
          variant="rounded"
          sx={{
            width: "fit-content",
            height: "fit-content",
            px: "0.4rem",
            py: "0.4rem",
            bgcolor: "hsl(var(--primary))", // green background
            color: "hsl(var(--primary-foreground))",
          }}
        >
          <ProjectCustomIcon
            sx={{ fontSize: font.size.fs_3, color: "inherit" }}
          />
        </Avatar>

        <Box className="flex-1 flex items-center justify-end gap-2  ">
          <LightTooltip
            title={
              <Box className="flex items-center gap-1">
                <Typography fontSize={font.size.fs_5} color="textPrimary">
                  {t("editText")}
                </Typography>
                {/* <ShortcutText keyboardShortcutText={KeyboardKeys.F2} textColor="textSecondary" /> */}
              </Box>
            }
          >
            <IconButton
  onClick={handleEdit}
  sx={{
    color: 'text.primary', // icon color (black in light mode)
    '&:hover': {
      backgroundColor: (theme) => `${theme.palette.primary.main}22`, // adds transparency (~13%)
      color: (theme) => theme.palette.primary.main, // icon turns primary color on hover
    },
    transition: 'all 0.2s ease-in-out',
  }}
>
  <EditOutlined />
</IconButton>
          </LightTooltip>

          <LightTooltip
            title={
              <Box className="flex items-center gap-1 ">
                <Typography fontSize={font.size.fs_5} color="textPrimary">
                  {t("deleteText")}
                </Typography>
                {/* <ShortcutText keyboardShortcutText={KeyboardKeys.Delete} textColor="textSecondary" /> */}
              </Box>
            }
          >
            <IconButton
              onClick={handleDelete}
              sx={{
                color: "text.primary", // icon color (black in light, can be overridden)
                "&:hover": {
                  backgroundColor: "rgba(255, 0, 0, 0.1)", // light red background
                  color: "error.main", // optional: make icon red on hover
                },
                transition: "all 0.2s ease-in-out",
              }}
            >
              <DeleteOutline />
            </IconButton>
          </LightTooltip>
        </Box>
      </Box>

      {/* main container */}
      <Box
        className="flex-1 flex flex-col  gap-4  "
        // onClick={() => { handleClick(item, ModulePath.requirements) }}
      >
        <Box className="flex-1 flex flex-col gap-0  cursor-pointer ">
          <Typography
            fontSize={font.size.fs_4}
            className="text-foreground line-clamp-1  text-black dark:text-white"
          >
            {item?.name}
          </Typography>
          <Typography
            fontSize={font.size.fs_5}
            className="text-muted-foreground line-clamp-2  text-black dark:text-white"
          >
            {item?.description}
          </Typography>
        </Box>

        {/* bottom container */}
        <Box className="flex items-center flex-wrap gap-2  text-black dark:text-white  ">
          <ItemCount
            icon={
              <UserStoryCustomIcon
                style={{ color: CARD_COLOR[Entity.userStory] }}
              />
            }
            label={"User Stories"}
            value={item?.userStoryCount}
            onClick={(e) => {
              e.stopPropagation();
              handleClick(item, ModulePath.requirements);
            }}
          />
          <ItemCount
            icon={
              <UseCaseCustomIcon
                style={{ color: CARD_COLOR[Entity.useCase] }}
              />
            }
            label={"Use Cases"}
            value={item?.useCaseCount}
            onClick={(e) => {
              e.stopPropagation();
              handleClick(item, ModulePath.useCase);
            }}
          />
          <ItemCount
            icon={
              <TestCaseCustomIcon
                style={{ color: CARD_COLOR[Entity.testCase] }}
              />
            }
            label={"Test Cases"}
            value={item?.testCaseCount}
            onClick={(e) => {
              e.stopPropagation();
              handleClick(item, ModulePath.testCase);
            }}
          />
        </Box>

        <Box className="w-full flex items-center gap-2 flex-nowrap">
          <Tooltip title={item?.categoryName} arrow>
            <Chip
              size="small"
              label={
                <span className="block max-w-[90px] truncate  text-black dark:text-white">
                  {item?.categoryName}
                </span>
              }
              className="bg-accent/10 text-accent  text-black dark:text-white "
              sx={{
                fontSize: font.size.fs_6,
                background: "hsl(var(--background))",
                color: "hsl(var(--primary-foreground))",
                foreground: "hsl(var(--accent-foreground))",
                border: "1px solid hsl(var(--border))",
                cursor: "pointer",
              }}
            />
          </Tooltip>

          <Chip
            size="small"
            label={
              <span className="block max-w-[90px] truncate  text-black dark:text-white">
                {item?.subCategoryName}
              </span>
            }
            className="bg-accent/10 text-accent  text-black dark:text-white  "
            sx={{
              fontSize: font.size.fs_6,
              background: "hsl(var(--background))",
              color: "hsl(var(--primary-foreground))",
              foreground: "hsl(var(--accent-foreground))",
              border: "1px solid hsl(var(--border))",
              cursor: "pointer",
            }}
          />

          {item?.createdBy && (
            // Use theme colors for CreatedByAvatar
            <Box
              sx={{
                // In light mode, use theme's primary color
                ...(theme.palette.mode === "light" && {
                  "& .MuiAvatar-root": {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.secondary,
                    border: "0px solid white",
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
                  },
                  "& .MuiSvgIcon-root": {
                    color: theme.palette.primary.contrastText,
                  },
                }),
                // In dark mode, make it white with primary color border
                ...(theme.palette.mode === "dark" && {
                  "& .MuiAvatar-root": {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.text.primary.contrastText,
                    border: `2px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
                  },
                  "& .MuiSvgIcon-root": {
                    color: theme.palette.text.primary,
                  },
                }),
              }}
            >
              <CreatedByAvatar data={item} />
            </Box>
          )}
        </Box>
      </Box>

      <Menu
        anchorEl={moreAnchorEl}
        open={Boolean(moreAnchorEl)}
        onClose={handleCloseMore}
        slotProps={{
          paper: {
            sx: {
              background: "hsl(var(--background))",
              color: "hsl(var(--primary-foreground))",
              border: "1px solid hsl(var(--border))",
              input: "hsl(var(--input))",
            },
          },
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            onClick={handleCloseMore}
            className="flex items-center gap-2"
          >
            {option?.icon}
            {option?.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

export default ProjectCard;

function ItemCount({ icon, label, value, ...props }) {
  return (
    <Chip
      icon={<span className="text-black dark:text-white">{icon}</span>}
      label={`${label}: ${value}`}
      size="small"
      variant="outlined"
      className="
        border-border
        text-foreground
        bg-transparent
       text-black
        dark:text-white
      "
      onClick={props.onClick}
    />
  );
}

function ItemCount2({ icon, label, value }) {
  const theme = useTheme();

  return (
    <Box className="flex items-center gap-1 ">
      <span className="text-black dark:text-white">{icon}</span>
      <Typography
        fontSize={font.size.fs_6}
        className="whitespace-nowrap text-black dark:text-white  "
      >
        {label}:
      </Typography>
      <Typography
        fontSize={font.size.fs_6}
        color={theme.palette.text.secondary}
        className=" whitespace-nowrap "
      >
        {value}
      </Typography>
    </Box>
  );
}
